import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MerchantCESComponent } from './crud-ces/crud-ces.component';
import { MerchantIndexComponent } from './crud-index/crud-index.component';
import { MerchantUsersFormComponent } from './merchant-users/merchant-users-form.component';
import { MerchantUsersIndexComponent } from './merchant-users/merchant-users-index.component';

const routes: Routes = [
  {
    path: '',
    component: MerchantIndexComponent,
  },
  {
    path: 'create',
    component: MerchantCESComponent,
    data: [{ action: 'create' }],
  },
  {
    path: 'view/:id',
    component: MerchantCESComponent,
    data: [{ action: 'view' }],
  },
  {
    path: 'edit/:id',
    component: MerchantCESComponent,
    data: [{ action: 'edit' }],
  },
  {
    path: 'onMyAccount',
    component: MerchantIndexComponent,
    data:{view: true}
  },
  {
    path: 'users',
    component: MerchantUsersIndexComponent,
  },
  {
    path: 'users/create',
    component: MerchantUsersFormComponent,
  },
  {
    path: 'users/edit/:id',
    component: MerchantUsersFormComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MerchantsRoutingModule {}
